export const version = '2.10.2';
//# sourceMappingURL=version.js.map